import * as Icons from "lucide-react";

function getBlock(page, type) {
  return (
    (page?.sections || [])
      .flatMap((section) => section.blocks || [])
      .find((block) => block.type === type)?.data || {}
  );
}

function Icon({ name, ...rest }) {
  const key = (name || "")
    .split("-")
    .map((w) => w[0]?.toUpperCase() + w.slice(1))
    .join("");

  const C = Icons[key] || Icons.Sparkles;

  return <C {...rest} />;
}

export default function ContactInfo({ page, compact = false }) {
  const hero = getBlock(page, "contact_hero");
  const details = getBlock(page, "contact_details");

  const cards = details.items || [];

  return (
    <div>
      {!compact && (
        <>
          <div className="text-xs font-semibold uppercase tracking-widest text-[#006B3C]">
            {hero.badge}
          </div>

          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">
            {hero.title}
          </h1>

          <p className="mt-5 text-lg text-gray-600">
            {hero.description}
          </p>
        </>
      )}

      <div className={compact ? "space-y-5" : "mt-10 space-y-5"}>
        {cards.map((card, index) => (
          <div
            key={index}
            className="flex items-start gap-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#006B3C] text-[#ffffff]">
              <Icon name={card.icon} size={20} />
            </div>

            <div>
              <h3 className="text-sm font-semibold text-gray-900">
                {card.title}
              </h3>

              {card.link1 ? (
                <a
                  href={card.link1}
                  className="mt-1 block text-gray-600 hover:text-[#538135]"
                >
                  {card.line1}
                </a>
              ) : (
                card.line1 && (
                  <div className="mt-1 text-gray-600">
                    {card.line1}
                  </div>
                )
              )}

              {card.link2 ? (
                <a
                  href={card.link2}
                  className="block text-gray-600 hover:text-[#538135]"
                >
                  {card.line2}
                </a>
              ) : (
                card.line2 && (
                  <div className="text-gray-600">
                    {card.line2}
                  </div>
                )
              )}

              {card.line3 && (
                <div className="text-gray-600">
                  {card.line3}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}